// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import riskMitigationEntity from './entities/risk-mitigation.json';
import riskMitigationMenu from '../pages/risk-mitigation/menu.json';
import riskMitigationFullForm from '../pages/risk-mitigation/forms/full.json';
import riskMitigationContextForm from '../pages/risk-mitigation/forms/context.json';
import riskMitigationMiniForm from '../pages/risk-mitigation/forms/mini.json';
import riskMitigationLookupForm from '../pages/risk-mitigation/forms/lookup.json';
import riskMitigationTableView from '../pages/risk-mitigation/views/table.json';
import riskMitigationCardsView from '../pages/risk-mitigation/views/cards.json';
import riskMitigationDashboardView from '../pages/risk-mitigation/views/dashboard.json';

/** Тип запису «Захід зі зниження ризику» зі сторінками пакета: меню, форми та подання з pages/risk-mitigation/. */
export const riskMitigationDefinition: IRecordTypeDefinition = {
  ...riskMitigationEntity,
  views: assembleViewSet({
      table: riskMitigationTableView,
      cards: riskMitigationCardsView,
      dashboard: riskMitigationDashboardView,
  }),
  form: riskMitigationFullForm,
  forms: { full: riskMitigationFullForm, context: riskMitigationContextForm, mini: riskMitigationMiniForm, lookup: riskMitigationLookupForm },
  menu: riskMitigationMenu,
} as IRecordTypeDefinition;
